export const URGENCIES = {
  5: {
    id: 1,
    value: 5,
    icon: 'simple-clock',
    size: 40,
    text: 'Ready to hire',
    key: 'readytohire',
  },
  6: {
    id: 2,
    value: 6,
    size: 40,
    icon: 'calendar-unknown',
    text: 'Planning and researching',
    key: 'planning',
  },
};

export const URGENCY_LABELS = {
  1: 'Ready to hire',
  2: 'Project planning',
};

export const DEFAULT_URGENCY = 2;
